import * as Sentry from '@sentry/browser';

import { ANALYTICS_TRAFFIC } from './analytics-constants';
import { getHubspotEventsConfig } from './hubspot-events-config';

type User = Readonly<{
  id?: number;
  guest?: boolean;
  is_staff?: boolean;
  email?: string;
}>;
declare global {
  interface Window {
    _hsq?: { push: (command: unknown[]) => unknown };
  }
}

let currentUser: User | undefined;

export function update(user: User): void {
  currentUser = user;
}

export function reset(): void {
  currentUser = undefined;
}

export function trackEvent(eventName: string, eventProps: Readonly<Record<string, unknown>>): void {
  try {
    const config = getHubspotEventsConfig()[eventName];
    if (!config || !currentUser || !ANALYTICS_TRAFFIC.enabled || ANALYTICS_TRAFFIC.trafficType !== 'production') return;
    if (currentUser.is_staff) return;
    if (document.cookie.split(';').some(c => /^__(hs_opt_out|hs_do_not_track)=yes$/.test(c.trim()))) return;
    if (config.filter && !config.filter(eventProps)) return;

    const properties: Record<string, string | number | boolean> = {
      source: typeof eventProps.source === 'string' ? eventProps.source : 'website',
      source_event: eventName,
    };
    for (const [target, source] of Object.entries(config.property_mapping)) {
      const value = typeof source === 'function' ? source(eventProps) : eventProps[source];
      if (
        typeof value === 'string' ||
        typeof value === 'boolean' ||
        (typeof value === 'number' && Number.isFinite(value))
      )
        properties[target] = value;
    }
    const initialQueue: unknown[][] = [];
    const queue = (window._hsq ||= initialQueue);
    if (!currentUser.guest) {
      // Identify the current account before sending its event, including after an in-session login.
      queue.push(['identify', { email: currentUser.email, id: currentUser.id }]);
      properties.wize_user_id = String(currentUser.id);
    }
    queue.push(['trackCustomBehavioralEvent', { name: config.event_id, properties }]);
  } catch (error) {
    Sentry.captureException(error, { tags: { analytics_destination: 'hubspot' } });
  }
}
